<template>
    <div class="matching-products">
        
        <div v-if="searchType == 'SEARCH_PRODUCT'">
            <div v-if="searchContentLoader" class="contentLoaderWrap">
                <q-spinner color="primary" size="5em" :thickness="6" />
                <div class="loadingText">Loading Results</div>
            </div>
            <div v-else>
                <MatchingProductsDetails :product="product" v-for="product in props.products" :key="`pros+${product.id}`"  />
            </div>
        </div>

        <div v-else-if="searchType == 'L2_PRODUCT'">
            <div v-if="searchContentLoader" class="contentLoaderWrap">
                <q-spinner color="primary" size="5em" :thickness="6" />
                <div class="loadingText">Loading Results</div>
            </div>
            <div v-else>
                <MatchingL2ProductsDetails :products="products" />
            </div>
        </div>  
    </div>
</template>

<script setup>
import { defineProps } from "vue";
import { storeToRefs } from 'pinia'
import { useDropdownSearchStore } from '../../stores/dropdown-search-store.js';
import MatchingProductsDetails from "./MatchingProductsDetails.vue"
import MatchingL2ProductsDetails from "./MatchingL2ProductsDetails.vue"

const dropdownSearchStore = useDropdownSearchStore();
const {searchContentLoader} = storeToRefs(dropdownSearchStore);


const props = defineProps({
    products: Array,
    searchType: String,
})
</script>

<style scoped lang="scss">
.matching-products {
    // padding: 12px 13px 10px 12px;
    // background: #FEFEFE;
    // border: 1px solid #B3B3B3;
    // border-radius: 8px;
}
.contentLoaderWrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 300px;
    .loadingText{
        font-size: 17px;
        padding: 15px 0px;
    }
}
</style>